import React, { useState } from 'react';
import { FiCopy, FiCheck, FiExternalLink } from 'react-icons/fi';

const Installation = () => {
  const [copied, setCopied] = useState(false);

  const handleCopy = () => {
    navigator.clipboard.writeText('npm install sl-address');
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <section id="install" className="py-20 px-4">
      <div className="max-w-4xl mx-auto text-center">
        <h2 className="section-heading text-4xl md:text-5xl font-heading font-bold mb-12 gradient-text">
          Get Started in Seconds
        </h2>

        {/* npm install command box */}
        <div className="install-command bg-primary-950 rounded-xl p-6 flex items-center justify-between max-w-xl mx-auto mb-12 border border-white/[0.08]">
          <code className="font-mono text-lg text-white">
            npm install sl-address
          </code>
          <button
            onClick={handleCopy}
            className="ml-4 text-gray-400 hover:text-white transition-colors p-2 rounded-lg hover:bg-white/10"
            aria-label="Copy install command"
          >
            {copied ? (
              <FiCheck className="w-5 h-5 text-accent-400" />
            ) : (
              <FiCopy className="w-5 h-5" />
            )}
          </button>
        </div>

        {/* Quick start code example */}
        <div className="install-code bg-primary-950 rounded-xl overflow-hidden text-left max-w-3xl mx-auto mb-12 border border-white/[0.08]">
          <div className="px-6 py-3 border-b border-white/10 flex items-center gap-2">
            <span className="w-3 h-3 rounded-full bg-red-500"></span>
            <span className="w-3 h-3 rounded-full bg-yellow-500"></span>
            <span className="w-3 h-3 rounded-full bg-green-500"></span>
            <span className="ml-4 text-gray-400 text-sm font-mono">
              quickstart.js
            </span>
          </div>
          <pre className="p-6 font-mono text-sm leading-relaxed overflow-x-auto">
            <code>
              <span className="text-purple-400">import</span>
              <span className="text-white"> sl </span>
              <span className="text-purple-400">from</span>
              <span className="text-green-400"> 'sl-address'</span>
              <span className="text-white">;</span>
              {'\n\n'}
              <span className="text-gray-500">{'// Get all provinces'}</span>
              {'\n'}
              <span className="text-purple-400">const</span>
              <span className="text-white"> provinces = </span>
              <span className="text-blue-300">sl</span>
              <span className="text-white">.</span>
              <span className="text-yellow-300">getProvinces</span>
              <span className="text-white">();</span>
              {'\n\n'}
              <span className="text-gray-500">{'// Search for a city'}</span>
              {'\n'}
              <span className="text-purple-400">const</span>
              <span className="text-white"> results = </span>
              <span className="text-blue-300">sl</span>
              <span className="text-white">.</span>
              <span className="text-yellow-300">searchCity</span>
              <span className="text-white">(</span>
              <span className="text-green-400">'colombo'</span>
              <span className="text-white">);</span>
              {'\n\n'}
              <span className="text-gray-500">{'// Get postal code info'}</span>
              {'\n'}
              <span className="text-purple-400">const</span>
              <span className="text-white"> info = </span>
              <span className="text-blue-300">sl</span>
              <span className="text-white">.</span>
              <span className="text-yellow-300">getInfoByPostal</span>
              <span className="text-white">(</span>
              <span className="text-green-400">'10280'</span>
              <span className="text-white">);</span>
              {'\n'}
              <span className="text-gray-500">{'// → { city: \'Maharagama\', district: \'Colombo\', province: \'Western\', postalCode: \'10280\' }'}</span>
              {'\n\n'}
              <span className="text-gray-500">{'// Fuzzy auto-complete'}</span>
              {'\n'}
              <span className="text-purple-400">const</span>
              <span className="text-white"> suggestions = </span>
              <span className="text-blue-300">sl</span>
              <span className="text-white">.</span>
              <span className="text-yellow-300">autocompleteCity</span>
              <span className="text-white">(</span>
              <span className="text-green-400">'kan'</span>
              <span className="text-white">);</span>
            </code>
          </pre>
        </div>

        {/* Action buttons */}
        <div className="install-actions flex flex-col sm:flex-row items-center justify-center gap-4">
          <a
            href="https://github.com/sumudu-k/sl-address"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 px-8 py-3 bg-gradient-to-r from-primary-500 to-accent-500 text-white rounded-full font-semibold hover:shadow-lg hover:shadow-primary-500/25 transition-all duration-300"
          >
            Full Documentation
            <FiExternalLink className="w-4 h-4" />
          </a>
          <a
            href="https://www.npmjs.com/package/sl-address"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 px-8 py-3 border-2 border-primary-400 text-primary-400 rounded-full font-semibold hover:bg-primary-500/10 transition-all duration-300"
          >
            View on npm
            <FiExternalLink className="w-4 h-4" />
          </a>
        </div>
      </div>
    </section>
  );
};

export default Installation;
